<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">This book is dedicated to the hellgrounds—and to all who labor there in high ideals, however vainly.</p>
<p class="right"><span>dp</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?20e56b86